<template>
  <v-card>
    <v-card-title>{{ $t('competitor.checkedIn') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.data.checkIns"
        hide-default-headers
        hide-default-footer
        disable-pagination
        disable-sort
      >
        <template v-slot:item.timestamp="{item}">
          {{ item.timestamp | datetime }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
  } from 'vuetify/lib'

  export default {
    name: 'FCCCompetitorCheckIns',
    computed: {
      headers: function(){
        return [
          { text: this.$t('ctrl.timestamp'), value: 'timestamp', align: 'left' },
          { text: this.$t('application.competition'), value: 'competition.title', align: 'left' },
          { text: this.$t('ctrl.user'), value: 'userId', align: 'left' }
        ];
      }
    },
    methods: {
        applicationType: function(i) {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
      }
    },
    props: {
      data: Object
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    }
  }
</script>